import { fetcher } from '@commenda/utils';
import { TCreateTPAuditPacketBody, TCreateTPAuditPacketResponse } from './types';

export async function createTPAuditPacket(
  body: TCreateTPAuditPacketBody
): Promise<TCreateTPAuditPacketResponse> {
  const response = await fetcher('tp-audit-packet', {
    method: 'POST',
    body,
  });
  if (!response.ok) throw new Error('Failed to create audit packet');
  return (await response.json()) as TCreateTPAuditPacketResponse;
}
